import React, { useContext, useEffect, useState } from 'react'
import {
  Container,
  InputDiv,
  InputLabel,
  Input,
  MediumInput,
  SmallInput,
  StyledSelect,
  SmallInputContainer,
  StyledOption
} from './style'
import ParametersContext, {
  MainFieldsParamObject,
} from '../../../../../contexts/ParametersContext'
import SectionContext from '../../../../../contexts/SectionContext'
import axios from 'axios'

interface MainFieldsNoIdObject {
  name: string
  paramClass: string
  family: string
  type: string
  astm: string
  uns: string
  din: string
  aisi: string
  others: string
}

interface CertificateTypes {
  id: number
  typeName: string
}

const MainFields: React.FC = () => {
  const { mainFields, setMainFields, parameters, editParameterIndex } = useContext(ParametersContext)
  const { certificatesSection } = useContext(SectionContext)
  const [isNameRepeated, setIsNameRepeated] = useState(false)
  const [ certificateTypes, setCertificateTypes ] = useState<CertificateTypes[]>([])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/certificate-type`)
      .then((response) => {
        if(response.data) setCertificateTypes(response.data)
        return
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    type OmitType = Omit<MainFieldsNoIdObject, 'type'>
    const { name, value } = e.target
    const newParameter = { ...mainFields }
    newParameter[name as keyof OmitType] = value
    const parametersToBeCompared = [...parameters]
    if (certificatesSection === 'editParameter') {
      parametersToBeCompared.splice(editParameterIndex, 1)
    }
    const repeatedName = parametersToBeCompared.some(
      (parameter) => parameter.name === value,
    )
    if (name === 'name' && repeatedName) {
      setIsNameRepeated(true)
    } else {
      setIsNameRepeated(false)
    }
    setMainFields(newParameter)
  }

  const handleSelectChange = (value: number|string) => {
    const objectType = certificateTypes.find((type) => type.id == value)
    if (objectType) {
      setMainFields((prevMainFields) => ({
        ...prevMainFields,
        type: objectType,
      }))
    }
  }

  const handleValues = (field:string):any => {
    if(field == 'type') 
      return mainFields.type.typeName
    return mainFields[field as keyof MainFieldsNoIdObject]
  }

  const similarFields = ['astm', 'uns', 'din', 'aisi', 'others']
  const similarFieldsHeaders = ['ASTM', 'UNS', 'DIN', 'AISI', 'Outras']

  return (
      <Container>
        <InputDiv>
          <InputLabel htmlFor='name'>Nome da norma*</InputLabel>
          <Input 
            placeholder='Digite aqui'
            name='name'
            value={mainFields.name}
            onChange={handleChange}
            autoComplete="off"
            className = {isNameRepeated ? 'redBorder' : ''}
          />
        </InputDiv>
        <InputDiv>
          <InputLabel htmlFor='paramClass'>Classe</InputLabel>
          <MediumInput 
            placeholder='Digite aqui'
            name='paramClass'
            value={mainFields.paramClass}
            onChange={handleChange}
            autoComplete="off"
          />
        </InputDiv>
        <InputDiv>
          <InputLabel htmlFor='family'>Família</InputLabel>
          <MediumInput 
            placeholder='Digite aqui'
            name='family'
            value={mainFields.family}
            onChange={handleChange}
            autoComplete="off"
          />
        </InputDiv>
        <InputDiv>
          <InputLabel htmlFor='type'>Tipo</InputLabel>
          <StyledSelect 
            name='type'
            value={mainFields.type.id ? mainFields.type.id : ''}
            onChange={(e) => handleSelectChange(e.target.value)}
            autoComplete="off"
          >
            <StyledOption defaultValue=''>Selecione</StyledOption>
            {certificateTypes.map((item, index) => (
              <StyledOption key={index} value={item.id}>{item.typeName}</StyledOption>
            ))}
          </StyledSelect>
        </InputDiv>
        <SmallInputContainer>
          {similarFields.map((item, index) => (
            <InputDiv key={item}>
              <InputLabel htmlFor={item}>{similarFieldsHeaders[index]}</InputLabel>
              <SmallInput 
                placeholder='Digite..'
                name={item}
                value={handleValues(item)}
                onChange={handleChange}
                autoComplete="off"
              />
            </InputDiv>
          ))}
        </SmallInputContainer>
      </Container>
  )
}
export default MainFields
